import { MALL_SORT_KEY, MALL_SORT } from '@/constants/mall'

import { ParamsType } from './index'

const denormalizer = (params: ParamsType) => {
  const { sortBy, order, ...rest } = params

  const currentSortByKey = sortBy !== undefined ? MALL_SORT_KEY[sortBy] : undefined // 理論上一次應該只會有一種 sort，未來如果有新的 sort 方式，也不用再多一個欄位，但後端在忙其他的，目前先這樣

  const isRecommendSort = sortBy === MALL_SORT.RECOMMEND // 如果是推薦排序，就是預設的排序，不需要傳 order 參數給後端

  return currentSortByKey && !isRecommendSort ? { ...rest, [currentSortByKey]: order } : { ...rest }
}

export default denormalizer
